export default "__VITE_ASSET__02f7f706__"